import { render } from "./QRCodeGenerator.vue?vue&type=template&id=2508c8b4&scoped=true"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"

import "./QRCodeGenerator.vue?vue&type=style&index=0&id=2508c8b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2508c8b4"]])

export default __exports__